import Modal from '@ui-components-3/ui/lib/components/Modal'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import CancelMedicationSchema, { CancelMedicationFormValues } from 'schemas/CancelMedication'
import { ErrorMessage } from '@hookform/error-message'
import ErrorFieldForm from 'components/UI/ErrorFieldForm'
import { useMemo } from 'react'
import useId from '@ui-components-3/ui/lib/hooks/useId'

type CancelMedicationModalProps = {
  cancelMedication: (values: CancelMedicationFormValues) => void
  onClose: () => void
}

const CancelMedicationModal = ({ cancelMedication, onClose }: CancelMedicationModalProps) => {
  const defaultValues = useMemo(() => CancelMedicationSchema.cast({}), [])

  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(CancelMedicationSchema),
    defaultValues,
  })

  const reasonId = useId('cancellationReason')

  return (
    <Modal
      label="Are you sure you want to cancel this prescription?"
      opened
      size="l"
      footerVariant="right"
      onClose={onClose}
      footer={({ close, idPrefix }) => (
        <>
          <button type="button" className="btn btn-neutral-outlined" onClick={close}>
            No
          </button>
          <button type="submit" className="btn btn-neutral" form={`${idPrefix}form`} disabled={!isValid}>
            Yes, cancel prescription
          </button>
        </>
      )}
    >
      {({ idPrefix }) => (
        <form id={`${idPrefix}form`} onSubmit={handleSubmit(cancelMedication)} className="py-2">
          <div className="flex flex-col gap-y-2.5">
            <label htmlFor={reasonId} className="typography-body font-medium leading-tight">
              Cancellation Reason
            </label>
            <textarea
              className="input"
              placeholder="Include more information"
              rows={3}
              autoComplete={'off'}
              id={reasonId}
              {...register('cancellationReason')}
            />
            <ErrorMessage errors={errors} name={'cancellationReason'} as={<ErrorFieldForm />} />
          </div>
        </form>
      )}
    </Modal>
  )
}

export default CancelMedicationModal
